import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import type { CardShipmentAddressType } from '@Store/slices/customer/customer.types';

interface CardShipmentAddressDto {
  cardShipmentAddressType: CardShipmentAddressType;
  mailingAddress?: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
}

export const setCardShipmentAddress = async (dto: CardShipmentAddressDto) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/card/address/shipment`
    : `v2/secureonboarding/user/${customerId}/business/card/address/shipment`;

  const { data } = await HttpService.post(url, dto);
  return data;
};

export const getCardShipmentAddress = async () => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/card/address/shipment`
    : `v2/secureonboarding/user/${customerId}/business/card/address/shipment`;

  const { data } = await HttpService.get(url);
  return data;
};
